import { filter, get, every, map } from 'lodash';
import { v1 as uuid } from 'uuid';
import {
  prepareValues,
  isDefaultRanges,
  hasUnderEighteenValue,
} from 'containers/TargetingPage/Criteria/AgeTargetingCard/helpers';

const MAX_ALLOWED_VALUES_WITH_QUOTA = 100;

export function setupCriterion(criterion, userHideAgeUnderEighteen) {
  if (criterion === undefined) return undefined;

  const { key } = criterion;
  switch (key) {
    case 'age': {
      const hideUnderEighteenValues =
        userHideAgeUnderEighteen && !hasUnderEighteenValue(criterion.values);

      const isDefault = isDefaultRanges(
        criterion.values,
        hideUnderEighteenValues,
      );
      const values = prepareValues(
        criterion.values,
        isDefault,
        hideUnderEighteenValues,
      );

      const valuesToUse = isDefault ? filter(values, 'enabled') : values;
      return { ...criterion, values: valuesToUse, isDefault };
    }
    case 'latlon': {
      const values = getRadiusValues(criterion.values);
      return { ...criterion, values };
    }
    case 'postal_code':
    case 'device_id':
    case 'developer_id':
    case 'api_key':
    case 'has_advertising_id':
    case 'has_os_version':
    case 'gender':
      return criterion;
    default:
      return criterion;
  }
}

export const canHaveQuotas = (selections = []) =>
  selections.length > 1 && selections.length <= MAX_ALLOWED_VALUES_WITH_QUOTA;

function getRadiusValues(selections = []) {
  return selections.map((radiusEntry) => {
    const [lat, lng, radius] = radiusEntry.value.split(',');
    if (!lat || !lng || !radius) {
      throw new Error(
        `[Radius] Values should match string lat,lng,radius got "${
          radiusEntry.value
        }" instead`,
      );
    }
    return Object.assign({}, radiusEntry, {
      refId: radiusEntry.refId || uuid(),
      area: {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
        radius: parseFloat(radius), // api expects meters, server sends km -> km * 1000 = meters
      },
    });
  });
}

export const getInitializedQuota = (values, enabled, completes) => {
  if (!enabled) return values;

  let updatedValues = null;
  const quotaIsNotInitialized = every(
    values,
    (selection) => get(selection, 'quotaCompletes', false) === false,
  );

  if (quotaIsNotInitialized) {
    const count = values.length;
    const itemQuotaCompletes = Math.floor(completes / count);
    const lastItemQuotaCompletes = completes - itemQuotaCompletes * (count - 1);
    const lastItem = values[count - 1];

    updatedValues = map(values, (selection) => {
      const isLastItem = selection === lastItem;
      const quotaCompletes = isLastItem
        ? lastItemQuotaCompletes
        : itemQuotaCompletes;
      return { ...selection, quotaCompletes };
    });

    return updatedValues;
  }
  return values;
};
